import { useState } from "react";
import Card from "./UI/Card";
import Button from "./UI/Button";
import classes from "./MaaltijdenForm.module.css";

const MaaltijdenForm = (props) => {
  const [enteredNaam, setEnteredNaam] = useState("");
  const [enteredOmschrijving, setEnteredOmschrijving] = useState("");
  const [enteredPrijs, setEnteredPrijs] = useState("");
  const [enteredDatum, setEnteredDatum] = useState("");

  const addMealHandler = (event) => {
    event.preventDefault();

    console.log(enteredNaam, enteredOmschrijving, enteredPrijs, enteredDatum);

    props.onAddMaaltijd(
      enteredNaam,
      enteredOmschrijving,
      enteredPrijs,
      enteredDatum
    );
  };

  const naamChangeHandler = (event) => {
    setEnteredNaam(event.target.value);
  };

  const omschrijvingChangeHandler = (event) => {
    setEnteredOmschrijving(event.target.value);
  };

  const prijsChangeHandler = (event) => {
    setEnteredPrijs(event.target.value);
  };

  const datumChangeHandler = (event) => {
    setEnteredDatum(event.target.value);
  };

  const clearHandler = () => {
    setEnteredNaam("");
    setEnteredOmschrijving("");
    setEnteredPrijs("");
    setEnteredDatum("");
  };

  return (
    <Card className={classes.input}>
      <form onSubmit={addMealHandler}>
        <label htmlFor="naam">Naam</label>
        <input
          id="naam"
          type="text"
          value={enteredNaam}
          onChange={naamChangeHandler}
        />
        <label htmlFor="omschrijving">Omschrijving</label>
        <input
          id="omschrijving"
          type="text"
          value={enteredOmschrijving}
          onChange={omschrijvingChangeHandler}
        />
        <label htmlFor="prijs">Prijs</label>
        <input
          id="prijs"
          type="text"
          value={enteredPrijs}
          onChange={prijsChangeHandler}
        />
        <label htmlFor="datum">Datum</label>
        <input
          id="datum"
          type="date"
          value={enteredDatum}
          onChange={datumChangeHandler}
        />
        <Button onClick={clearHandler}>Annuleren</Button>
        <Button type="submit">Toevoegen</Button>
      </form>
    </Card>
  );
};

export default MaaltijdenForm;